const doc = [({"da":({"js":({"merfoto":({"orders":({"total_with_delivery":({"delivery":"Levering", "total_price_including_vat":"Total pris (inklusiv moms):"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;